import React from "react";
import { useBCMSContext, BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, BCMSDefaultModel, useStateManager } from "bcms-react";
import Classes, { MobileDevice } from "model";

import { CenterContentContainer, ConfirmBannerView, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { InfoBanner } from "components/shared/views/ConfirmBannerView";
import { PrimaryButton, UITextInput } from "components/ui";
import UIPasswordInput from "components/ui/UIPasswordInput";

import "./styles.css";

export default function AuthorizedDeviceEnrollmentPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onChange: prop => value => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "mobile", prop ], value)
                .submit(setState);
        },

        onSubmit: evt => {
            const device = MobileDevice.init({ ...state.data.mobile.record, isEnrolled: true });
            const defaultDevice = BCMSDefaultModel.mobileDevice();
            const merge = BCMSDefaultModel.mergeRecords(device, defaultDevice);
            const newDevice = MobileDevice.init(merge);

            MobileDevice.create(newDevice)
                .submit(Classes);

            BCMSStateManagerCRUD.init(state)    
                .update([ "data", "mobile" ], newDevice)
                .submit(setState);
        },

        onClose: evt => {
          BCMSStateManagerCRUD.init(state)
            .update([ "ui", "confirmationBanner", "isActive" ], false)
            .submit(setState);
        }
    });

    return (
        <PageContainer className="authorized-device-enrollment-page" state={ { data, ui } } controller={ controller }>
            <AuthorizedDeviceEnrollmentContent />
        </PageContainer>
    );
}

export const getDefaultPageData = () => ({
    mobile: MobileDevice.init({})
});
export const getDefaultPageUI = () => ({
    confirmationBanner: { isActive: true }
});

function AuthorizedDeviceEnrollmentContent(props) {
    const { data, ui, onChange, onSubmit, onClose } = useStateManager();

    const device = data.mobile;
    const isEnrolled = device.isEnrolled;

    return (
        <PageContentView>
            { isEnrolled &&
                <>
                    { ui.confirmationBanner.isActive &&
                      <InfoBanner text="This device has been enrolled for biometric authentication." onClick={ onClose } dataPoint="Device_Enrollment_Banner" /> }
                    
                    <CenterContentContainer className="authorized-device-enrollment">
                        <ContentHeaderView text="Authorized Device Enrollment" />
                        
                        <div className="content-container">
                            <p>Unenrolling will disable biometric authentication on this device.</p>
                        
                        </div>
                        
                        <FormContainer className="authorized-device-enrollment-form">
                            <FormRowView text="Device Name (e.g. Mary's Phone)">
                                <UITextInput value={ device.name } disabled={ true } onChange={ onChange("name") } />
                            </FormRowView>
                            <FormButtonRow>
                                <DisabledPrompt>
                                    <PrimaryButton text="Unenroll" dataPoint="Device_Enrollment_Unenroll" />
                                </DisabledPrompt>
                            </FormButtonRow>
                        </FormContainer>
                    </CenterContentContainer>
                </>
            } 

            { !isEnrolled &&
                <CenterContentContainer className="authorized-device-enrollment">
                    <ContentHeaderView text="Authorized Device Enrollment" />
                    
                    <div className="content-container">
                        <p>Unenrolling will disable biometric authentication on this device.</p>
                    </div>
                    
                    <FormContainer className="authorized-device-enrollment-form">
                        <FormRowView text="Device Name (e.g. Mary's Phone)">
                            <UITextInput dataPoint="Device_Enrollment_Name" value={ device.name } onChange={ onChange("name") } />
                        </FormRowView>
                        <FormRowView text="*User ID">
                            <UITextInput dataPoint="Device_Enrollment_User" value={ device.userID } onChange={ onChange("userID") } />
                        </FormRowView>
                        <FormRowView text="*Password">
                            <UIPasswordInput dataPoint="Device_Enrollment_Password" value={ device.password } onChange={ onChange("password") } />
                        </FormRowView>
                        <FormButtonRow>
                            <PrimaryButton dataPoint="Device_Enrollment_Enroll" text="Enroll" onClick={ onSubmit } />
                        </FormButtonRow>
                    </FormContainer>
                </CenterContentContainer>
            }
      </PageContentView>
    );
}